/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { memo, useCallback } from "react";
import { setRedlineDatasetIdsToData } from "../../../../../../redux/ducks/CoverageRequirements/slice";
import { useAppDispatch } from "../../../../../../redux/hooks";
import useGetHubName from "../../../../../components/Socket/useGetHubName";
import useSocket from "../../../../../components/Socket/useSocket";

const DashboardStudySocket = memo(({ studyId }: { studyId: string }) => {
    const dispatch = useAppDispatch();

    const onMessageDashboardSocket = useCallback((msg: any) => {
        const data = msg.data
        const type = msg.type

        switch (type) {
            case 'updateDataset':
                dispatch(setRedlineDatasetIdsToData({ actionType: 'updateDataset', data, datasetId: data.id }))
                break
            case 'deleteDataset':
                dispatch(setRedlineDatasetIdsToData({ actionType: 'deleteDataset', datasetId: data.id }))
                break
            case 'addDataset':
                dispatch(setRedlineDatasetIdsToData({ actionType: 'addDataset', data }))
                break
            default:
                break
        }
    }, [])
    const hubNameDashboardSocket = useGetHubName(`coverageRequirementsDashboard_${studyId}`)
    useSocket(hubNameDashboardSocket, onMessageDashboardSocket)

    // Render nothing, as this component is only for setting up the socket
    return null;
})

export default DashboardStudySocket;